// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"9c44ae09","139":"53d9702d","245":"98f5213b","391":"ab45f0aa","651":"953a6e4e","672":"2c2b0d03","751":"ed1d722a","769":"1c6c6ea1","871":"5e810bc7","950":"a8527e84"}[chunkId] + ".chunk.js";
};